// extracted by mini-css-extract-plugin
export default {"root":"SwipingDownComponent__root--3GpuP"};